import { apiClient, isApiError } from "@/lib/apiClient";

const AUTH_EXEMPT_PATHS = [
	"/api/auth/me",
	"/api/auth/login",
	"/api/auth/verify-2fa",
	"/api/auth/google",
	"/api/auth/register",
	"/api/auth/forgot-password",
	"/api/auth/reset-password",
	"/api/auth/resend-verification",
	"/api/auth/verify-email",
];

function getRequestPath(url: string | undefined): string | null {
	if (!url) return null;
	try {
		return new URL(url, window.location.origin).pathname;
	} catch {
		return url.split(/[?#]/)[0] ?? null;
	}
}

function isAuthExempt(url: string | undefined): boolean {
	const path = getRequestPath(url);
	return path !== null && AUTH_EXEMPT_PATHS.includes(path);
}

apiClient.interceptors.response.use(
	(response) => response,
	(error: unknown) => {
		if (
			isApiError(error) &&
			error.response?.status === 401 &&
			!isAuthExempt(error.config?.url)
		) {
			window.dispatchEvent(new Event("kitsulab-auth-expired"));
		}
		return Promise.reject(error);
	},
);
